import getDisplayInformation from './get-display-information';
import { InsuranceProviderLogo } from './insurance-provider-logo';
import { MarketplaceLogo } from '../logo-components/marketplace-logo';
import { ProviderLogo } from '../logo-components/provider-logo';
import { FreightLogo } from '../logo-components/FreightLogo';

/**
 * @typedef {'icon'|'logo'|'alternateIcon'} LogoType
 */

/**
 * @param {object} props
 * @param {string|number} [props.providerId]
 * @param {string|number} [props.carrierId]
 * @param {string|number} [props.marketplaceId]
 * @param {string|number} [props.fillProviderId]
 * @param {string|number} [props.freightCarrierName]
 * @param {string|number} [props.freightCarrierScac]
 * @param {string|number} [props.insuranceProviderId]
 * @param {LogoType} [props.logoType] - Used by internal MarketplaceLogo and ProviderLogo
 * @param {boolean} [props.showIcon] - Used by internal InsuranceProviderLogo
 * @param {string} [props.className]
 * @returns {React.JSX.Element}
 */
const DataDrivenLogo = ({
  providerId,
  carrierId,
  marketplaceId,
  fillProviderId,
  freightCarrierName,
  freightCarrierScac,
  insuranceProviderId,
  logoType = 'logo',
  showIcon = false,
  ...rest
}) => {
  const displayInformation = getDisplayInformation({
    providerId,
    carrierId,
    marketplaceId,
    fillProviderId,
    insuranceProviderId,
  });

  if (marketplaceId !== undefined) {
    return <MarketplaceLogo displayInformation={displayInformation} type={logoType} {...rest} />;
  }

  if (insuranceProviderId !== undefined) {
    return <InsuranceProviderLogo displayInformation={displayInformation} showIcon={showIcon} {...rest} />;
  }

  if (freightCarrierName && freightCarrierScac) {
    return <FreightLogo freightCarrierName={freightCarrierName} freightCarrierScac={freightCarrierScac} {...rest} />;
  }

  return <ProviderLogo displayInformation={displayInformation} type={logoType} {...rest} />;
};

export default DataDrivenLogo;
